const swipeReveal = document.querySelectorAll(".swipe-reveal");
swipeReveal.forEach(swipeReveal => {
  const comp = swipeReveal.querySelector("#comp");
  const imgAfter = swipeReveal.querySelector("#imgAfter");
  const divider = swipeReveal.querySelector("#divider");
  const handle = swipeReveal.querySelector("#handle");
  const lblBefore = swipeReveal.querySelector("#lblBefore");
  const lblAfter = swipeReveal.querySelector("#lblAfter");
  let dragging = false;
  function setPosition(pct) {
    pct = Math.max(2, Math.min(98, pct));
    const p = pct + "%";
    divider.style.left = p;
    handle.style.left = p;
    imgAfter.style.clipPath = `inset(0 0 0 ${p})`;
    lblBefore.style.right = `calc(${100 - pct}% + 38px)`;
    lblAfter.style.left = `calc(${pct}% + 38px)`;
  }
  function getPercent(clientX) {
    const rect = comp.getBoundingClientRect();
    return (clientX - rect.left) / rect.width * 100;
  }

  /* ── Mouse ── */
  comp.addEventListener("mousedown", e => {
    dragging = true;
    comp.classList.add("dragging");
    setPosition(getPercent(e.clientX));
  });
  window.addEventListener("mousemove", e => {
    if (dragging) setPosition(getPercent(e.clientX));
  });
  window.addEventListener("mouseup", () => {
    dragging = false;
    comp.classList.remove("dragging");
  });

  /* ── Touch ── */
  comp.addEventListener("touchstart", e => {
    dragging = true;
    comp.classList.add("dragging");
    setPosition(getPercent(e.touches[0].clientX));
  }, {
    passive: true
  });
  window.addEventListener("touchmove", e => {
    if (dragging) setPosition(getPercent(e.touches[0].clientX));
  }, {
    passive: true
  });
  window.addEventListener("touchend", () => {
    dragging = false;
    comp.classList.remove("dragging");
  });

  /* initial position */
  setPosition(50);
});